import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Tabコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/tabs?background=transparent&variation=underline&modifier=label&version=react" target="_blank">こちら</a>
 */
export const Tab = ({ ...props }) => {
    return <View {...props} />
}

Tab.propTypes = {
    /**
     * タブのラベルとコンテンツ<font color="red">*</font>
     */
    itemList: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node,
            value: PropTypes.string,
            children: PropTypes.node
        })
    ).isRequired,
    /**
     * 現在選択しているタブ
     */
    activeIndex: PropTypes.number,
    /**
     * 初期表示で選択するタブ
     */
    defaultActiveIndex: PropTypes.number,
    /**
     * タイプ<br>
     * (i: number, value: string) => void
     */
    onTabChange: PropTypes.func,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Tab.defaultProps = {
    itemList: [],
    defaultActiveIndex: 0
}
